import { SPLIT_SAVE_MODE_NEW_PLAN } from '@/lib/storyboard-image-split';

export const SPLIT_PENDING_TAG_PREFIX = 'split-pending:';

export function isSplitPendingTagId(tagId: string | null | undefined): boolean {
  return typeof tagId === 'string' && tagId.startsWith(SPLIT_PENDING_TAG_PREFIX);
}

export function buildSplitPendingTagId(jobId: string): string {
  return `${SPLIT_PENDING_TAG_PREFIX}${jobId}`;
}

export function fallbackSplitPlanName(index: number): string {
  return `拆分 ${index}`;
}

export function resolveRestoredSplitTaskFields(input: {
  jobId: string;
  source: {
    gridSplit?: boolean;
    saveMode?: string | null;
    tagId?: string | null;
    reservedPlanName?: string | null;
  };
  trackTypeName?: string | null;
  fallbackIndex?: number;
}): { origin: 'image-split'; tagId: string | null; title: string } | null {
  if (!input.source.gridSplit) return null;
  const isNewPlan = input.source.saveMode === SPLIT_SAVE_MODE_NEW_PLAN;
  const tagId = isNewPlan ? buildSplitPendingTagId(input.jobId) : (input.source.tagId ?? null);
  const title =
    input.source.reservedPlanName?.trim() ||
    input.trackTypeName?.trim() ||
    fallbackSplitPlanName(input.fallbackIndex ?? 1);
  return { origin: 'image-split', tagId, title };
}
